import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

interface ResetMapButtonProps {
  defaultCenter: [number, number];
  defaultZoom: number;
}

/**
 * A Leaflet control component that adds a reset view button to the map
 * @param defaultCenter The default center coordinates to reset to
 * @param defaultZoom The default zoom level to reset to
 */
const ResetMapButton: React.FC<ResetMapButtonProps> = ({ defaultCenter, defaultZoom }) => {
  const map = useMap();
  
  useEffect(() => {
    // Create a custom Leaflet control
    const ResetControl = L.Control.extend({
      options: {
        position: 'topright'
      },
      
      onAdd: function() {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        const button = L.DomUtil.create('a', 'reset-view-button', container);
        
        button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon></svg>';
        button.title = 'Reset map view';
        button.href = '#';
        button.style.lineHeight = '26px';
        button.style.textAlign = 'center';
        button.style.width = '30px';
        button.style.height = '30px';
        button.style.display = 'flex';
        button.style.alignItems = 'center';
        button.style.justifyContent = 'center';
        
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.on(button, 'click', function(e) {
          L.DomEvent.preventDefault(e);
          map.setView(defaultCenter, defaultZoom);
        });
        
        return container;
      }
    });
    
    // Add the control to the map
    const resetControl = new ResetControl();
    map.addControl(resetControl);
    
    // Cleanup on unmount
    return () => {
      map.removeControl(resetControl);
    };
  }, [map, defaultCenter, defaultZoom]);
  
  return null; // This component doesn't render anything directly
};

export default ResetMapButton;